import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicRoomSystem, UpdateRoomSystemDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateRoomSystem = async ({
  id,
  organisationId,
  roomSystem,
}: {
  id: string;
  organisationId: string;
  roomSystem: UpdateRoomSystemDto;
}): Promise<PublicRoomSystem> => {
  const response = await axiosClient.patch(
    `${organisationId}/room-systems/${id}`,
    roomSystem,
  );
  return response.data;
};

function useUpdateRoomSystem(
  mutationOptions?: UseMutationOptions<
    PublicRoomSystem,
    HttpError,
    { id: string; organisationId: string; roomSystem: UpdateRoomSystemDto }
  >,
) {
  return useMutation({
    mutationFn: updateRoomSystem,
    ...mutationOptions,
  });
}

export { useUpdateRoomSystem };
